import Symbol from './Symbol';
import SymbolFactory from './SymbolFactory';
import GeometryFactory from '../geometry/GeometryFactory';

/**
 * 面符号基类,所有面符号均从此类派生.
 */
export default class FillSymbol extends Symbol {
    /**
     * 重写父类初始化方法
     * @param {Object} options - 符号设置的属性
     * @returns {undefined}
     */
    constructor(options) {
        super(options);

        this.opacity = 1;
        this.outLine = null;
    }

    /**
     * 重写父类方法,设置符号属性.
     * @param {Object} json - 符号设置的属性
     * @returns {undefined}
     */
    fromJson(json) {
        super.fromJson(json);

        this._setValue('opacity', json.opacity);
        if (json.outLine) {
            const symbolFactory = SymbolFactory.getInstance();
            this.outLine = symbolFactory.createSymbol(json.outLine);
        }
    }

    /**
     * 重写父类方法,导出符号属性.
     * @returns {Object} json - 符号的属性
     */
    toJson() {
        const json = super.toJson();

        json.opacity = this.opacity;
        if (this.outLine) {
            json.outLine = this.outLine.toJson();
        }

        return json;
    }

    /**
     * 绘制接口.
     * @param {Object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * @returns {undefined}
     */
    draw(ctx, geometry) {
        if (
            !geometry ||
            !geometry.coordinates ||
            geometry.coordinates.length === 0 ||
            geometry.coordinates[0].length < 3
        ) {
            return;
        }

        // 保存当前状态，方便绘制完成后恢复状态
        ctx.save();

        this._drawSymbol(ctx, geometry);

        // 绘制完成后恢复到上次保存的状态，避免影响以后的绘制
        ctx.restore();
    }

    /**
     * 实际的绘制符号方法.
     * @param {Object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * @return {undefined}
     */
    _drawSymbol(ctx, geometry) {
        // 绘制符号内容
        this._drawContent(ctx, geometry);

        // 绘制符号轮廓线
        if (this.outLine) {
            this._drawOutLine(ctx, geometry);
        }
    }

    /**
     * 绘制符号内容
     * @param {Object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * @return {undefined}
     */
    _drawContent(ctx) {}

    /**
     * 绘制面的轮廓.
     * @param {Object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * @return {undefined}
     */
    _drawOutLine(ctx, geometry) {
        if (this.outLine.otherLine) {
            geometry.coordinates.forEach(geo => {
                this.outLine.draw(ctx, geo);
            })
        } else {
            this.outLine.draw(ctx, geometry.coordinates[0]);
        }
    }

    /**
     * 获得面符号的外包框.
     * @returns {Object} bound - 包含面的最小范围对象
     */
    getBound() {
        const gf = GeometryFactory.getInstance();

        const bound = this.geometry.getBound();

        return bound;
    }
}
